// Shared "Contract access" radio fieldset (All contracts / Selected) used by
// both the create-user and edit-user forms in OrgUsersTab. Only rendered by
// the caller when manage access is granted.
// `name` must be unique per rendered instance so the two radios group
// correctly (the two forms pass distinct names).
import { clsx } from 'clsx';
import type { ContractAccess } from '../../types';

interface ContractAccessFieldsetProps {
  name: string;
  isAdmin: boolean;
  contractAccess: ContractAccess;
  onChange: (value: ContractAccess) => void;
}

export default function ContractAccessFieldset({
  name,
  isAdmin,
  contractAccess,
  onChange,
}: ContractAccessFieldsetProps) {
  return (
    <div>
      <fieldset>
        <legend className="label">Contract access</legend>
        <div className="flex flex-col gap-2 py-1">
          <label className={clsx(
            'flex items-center gap-2',
            isAdmin ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
          )}>
            <input
              type="radio"
              name={name}
              value="all"
              checked={contractAccess === 'all'}
              disabled={isAdmin}
              onChange={() => onChange('all')}
              className="h-4 w-4 border-slate-300 text-brand-600 focus:ring-brand-500"
            />
            <span className="text-body-sm text-slate-700 dark:text-slate-300">All contracts</span>
          </label>
          <label className={clsx(
            'flex items-center gap-2',
            isAdmin ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
          )}>
            <input
              type="radio"
              name={name}
              value="selected"
              checked={contractAccess === 'selected'}
              disabled={isAdmin}
              onChange={() => onChange('selected')}
              className="h-4 w-4 border-slate-300 text-brand-600 focus:ring-brand-500"
            />
            <span className="text-body-sm text-slate-700 dark:text-slate-300">Selected</span>
          </label>
        </div>
        {isAdmin && (
          <p className="text-caption text-slate-400 dark:text-slate-500 mt-1">
            Admins always have access to all contracts.
          </p>
        )}
      </fieldset>
    </div>
  );
}
